

.container {

  display: flex;

  padding: 0.5em;

  border-radius: var(--border-radius);
  border: 1px solid var(--beigedarker);

  .inputWrapper
  {
    position: relative;
    display: flex;
    flex-grow: 1;
    align-items: center;
    gap: 0.75em;

    .input{

      display: block;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0;
      cursor: pointer;
    }

    &:hover .button
    {
      background-color: var(--beigedark);
    }



    .button
    {
      color: white;
      display: inline-flex;
      background-color: var(--beigedarker);
      border-radius: var(--border-radius);
      padding: .5rem 20px .5rem;
    }
    //button {
    //
    //  cursor: pointer;
    //}

    .filename
    {
      flex: 1;
    }

  }




  .clear {


  }
}
